package org.example.project

import org.example.project.client.JsApiClientFactory
import org.example.project.client.api.ActivityApiClient
import org.example.project.client.config.ApiConfig
import org.example.project.client.session.SessionRepository

actual object WebPlatformClient {
    actual fun createSessionRepository(apiConfig: ApiConfig): SessionRepository =
        JsApiClientFactory.createSessionRepository(apiConfig)

    actual fun createActivityApiClient(apiConfig: ApiConfig): ActivityApiClient =
        JsApiClientFactory.createActivityApiClient(apiConfig)

    actual fun createPlannerApiClient(apiConfig: ApiConfig): org.example.project.client.api.PlannerApiClient =
        JsApiClientFactory.createPlannerApiClient(apiConfig)

    actual fun createPlannerRepository(sessionRepository: SessionRepository, apiConfig: ApiConfig): org.example.project.planner.PlannerRepository =
        JsApiClientFactory.createPlannerRepository(sessionRepository, apiConfig)

    actual fun getBrowserOrigin(): String? = try {
        kotlinx.browser.window.location.origin.takeIf { it.isNotBlank() }
    } catch (_: Throwable) {
        null
    }

    actual fun getBrowserQueryParam(name: String): String? = try {
        val search = kotlinx.browser.window.location.search
        if (search.startsWith("?")) {
            search.substring(1).split("&").mapNotNull {
                val pair = it.split("=", limit = 2)
                if (pair.size == 2 && pair[0] == name) pair[1] else null
            }.firstOrNull()
        } else null
    } catch (_: Throwable) {
        null
    }

    actual fun getBrowserMetaTag(name: String): String? = try {
        kotlinx.browser.document.querySelector("meta[name='$name']")?.getAttribute("content")?.takeIf { it.isNotBlank() }
    } catch (_: Throwable) {
        null
    }
}
